import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import ProductExplorerComponent from '../components/ProductExplorerComponent';


export const StepNewProductList = ({
  commercialProducts,
  selectedCommercialProductGroup,
  selectedCommercialProduct,
  product,
  dateFormat,
  strings,
  handleFetchProducts,
  handleSelectProduct,
  handleSelectCPChange,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedOption, setSelectedOption] = useState(selectedCommercialProduct);
  const [iframeWidth] = useState('100%'); // Set your desired width
  const [iframeHeight] = useState('600px'); // Set your desired height
  const prevPropRef = useRef();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    handleSelectCPChange(option);
  };

  const handleButtonClick = () => {
    if (selectedDate && selectedOption) {
      // Action to be performed when both date and option are selected
      handleSelectProduct({ value: selectedOption.value, date: selectedDate })
    } else {
      alert('Please select a date and an option.');
    }
  };

  const commProductGroup = commercialProducts.get(selectedCommercialProductGroup)?.toJS();

  const extractOptions = ({ commProductGroup }) => {
    let options = [];
    if (Array.isArray(commProductGroup?.products)) {
      options = commProductGroup.products.map(commProduct => {
        const attachments = commProduct?.custom_resources?.attachments;
        return ({
          value: commProduct?.id,
          label: commProduct?.label,
          attachments
        });
      })
    }
    return options;
  }

  const options = extractOptions({ commProductGroup });

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    if (selectedCommercialProductGroup) {
      const elementToScroll = document.getElementById('step-product-list');
      setTimeout(function () {
        window.scrollTo({
          top: elementToScroll.offsetTop - 0,
          behavior: "smooth"
        });
      }, 2);
      
      if (prevPropRef.current !== undefined && prevPropRef.current !== selectedCommercialProductGroup) {
        setSelectedOption(null);
      }
      prevPropRef.current = selectedCommercialProductGroup;
    }
  });

  return (
    <div className="step StepNewProductList" id='step-product-list'>
      {selectedCommercialProductGroup && (
        <ProductExplorerComponent
          id="stepproductlist"
          widgetTitle={`${strings[product.title] || product.title} ${commProductGroup?.name ?? ''}`}
          widgetSubTitle={strings[product.subtitle] || product.subtitle}
          productLabel={strings[product.label] || product.label}
          productPlaceholder={strings[product.placeholder] || product.placeholder}
          dateLabel={get(strings, 'date.label', "Date d'effet des garanties souhaitée")}
          strings={strings}
          dateFormat={dateFormat}
          options={options}
          handleDateChange={handleDateChange}
          handleSelectChange={handleSelectChange}
          handleButtonClick={handleButtonClick}
          selectedDate={selectedDate}
          selectedOption={selectedCommercialProduct}
          iframeWidth={iframeWidth}
          iframeHeight={iframeHeight}
        />
      )}
    </div>
  );
};

StepNewProductList.propTypes = {
  commercialProducts: PropTypes.object,
  selectedCommercialProduct: PropTypes.object,
  selectedCommercialProductGroup: PropTypes.string,
  product: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  dateFormat: PropTypes.string.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  handleFetchProducts: PropTypes.func,
  handleSelectProduct: PropTypes.func,
  handleSelectCPChange: PropTypes.func,
};

StepNewProductList.defaultProps = {
  commercialProducts: {},
  selectedCommercialProduct: undefined,
  product: {
    title: 'product.title',
    subtitle: 'product.subtitle',
    label: 'product.select.label',
    placeholder: 'product.select.placeholder',
  },
  dateFormat: 'YYYY-MM-DD',
  strings: {},
  handleFetchProducts: params => console.log('handleFetchProducts ::', params),
  handleSelectProduct: params => console.log('handleSelectProduct ::', params),
  handleSelectCPChange: params => console.log('handleSelectCPChange ::', params),
};
